import script from "./ManageEnrichments.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageEnrichments.vue?vue&type=script&setup=true&lang=js"

import "./ManageEnrichments.vue?vue&type=style&index=0&id=11a67d90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a67d90"]])

export default __exports__